/**
 * Política pura de autenticação (Auth Fase 2) — sem dependências (testável).
 * Separado de `authRefresh.js` (que importa axios) para poder ser testado no
 * Jest do CRA sem esbarrar no transform de ESM do axios.
 */

/** Endpoints de auth que NÃO devem passar pelo fluxo de refresh (evita loop). */
export const isAuthEndpoint = (url) =>
	typeof url === "string" && /\/auth\/(login|refresh|logout)\b/.test(url);

/** Ação do front para cada `code` de 401 do contrato. */
export const decideOn401 = (code) => {
	switch (code) {
		case "TOKEN_EXPIRED":
		case "TOKEN_STALE":
			return "refresh";
		case "SESSION_REVOKED":
			return "logoff";
		case "AUTH_REQUIRED":
		case "INVALID_TOKEN":
			return "login";
		default:
			return "login"; // 401 sem code conhecido: tratar como precisa autenticar
	}
};
